import {
  Breadcrumbs,
  Card,
  Container,
  Icon,
  List,
  Section,
  Stack,
} from "@storoey/sui";
import { createFileRoute, useNavigate } from "@tanstack/solid-router";
import { createDexieArrayQuery } from "solid-dexie";
import { For, onMount } from "solid-js";
import { database } from "../../backend/database";
import { useNavbar } from "../../contexts/RootContext";

export const Route = createFileRoute("/history/")({
  staticData: {
    navTitle: "Historie",
    backLabel: "Hjem",
    backTo: "/",
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { setTitle } = useNavbar();
  const navigate = useNavigate();

  const forms = createDexieArrayQuery(() => database.forms.reverse().toArray());

  onMount(() => {
    setTitle("Historie");
  });

  return (
    <Section
      padding="lg"
      breadcrumbs={
        <Container>
          <Breadcrumbs>
            <Breadcrumbs.Item onClick={() => navigate({ to: "/" })}>
              Hjem
            </Breadcrumbs.Item>
            <Breadcrumbs.Item current>Historie</Breadcrumbs.Item>
          </Breadcrumbs>
        </Container>
      }
    >
      <Container>
        <Stack>
          <Card elevation={200}>
            <Card.Content>
              <Card.Title>Historie</Card.Title>
              <Card.Text>Liste over tidligere utfylte</Card.Text>
            </Card.Content>
            <Card.Actions>
              <List>
                <For each={forms}>
                  {(form) => (
                    <List.Item
                      leading={<Icon>star</Icon>}
                      trailingText={Intl.DateTimeFormat("no-NB", {
                        dateStyle: "short",
                      }).format(form.createdAt)}
                      trailingIcon="chevron_right"
                      onClick={() =>
                        navigate({
                          to: `/history/${form.id}`,
                        })
                      }
                    >
                      {form.templateName}
                    </List.Item>
                  )}
                </For>
              </List>
            </Card.Actions>
          </Card>
        </Stack>
      </Container>
    </Section>
  );
}
